import { Middleware, combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import {
	FLUSH,
	PAUSE,
	PERSIST,
	PURGE,
	PersistConfig,
	REGISTER,
	REHYDRATE,
	createMigrate,
	persistReducer,
	persistStore,
} from 'redux-persist';
import session_storage from 'redux-persist/lib/storage/session';

import { applicationFormReducer } from '@app/redux/applicationForm/applicationForm.reducer';
import { applicationsReducer } from '@app/redux/applications/applications.reducer';
import { assetsReducer } from '@app/redux/assets/assets.reducer';
import { authReducer } from '@app/redux/auth/auth.reducer';
import { mfaReducer } from '@app/redux/mfa/mfa.reducer';

import { isDevelopment } from '@utils/environment';

import { authFormsReducer } from './authForms/authForms.reducer';
import { branchEnvironmentName, branchEnvironmentReducer } from './branchEnvironment/branchEnvironment.reducer';
import { migrations } from './migrations';
import { publicSettingsName, publicSettingsReducer } from './publicSettings/publicSettings.reducer';

export const reducer = combineReducers({
	assets: assetsReducer,
	auth: authReducer,
	applications: applicationsReducer,
	applicationForm: applicationFormReducer,
	mfa: mfaReducer,
	authForms: authFormsReducer,
	branchEnvironment: branchEnvironmentReducer,
	publicSettings: publicSettingsReducer,
});

const persistConfig: PersistConfig<ReturnType<typeof reducer>> = {
	key: 'root',
	storage: session_storage,
	blacklist: [branchEnvironmentName, publicSettingsName],
	version: 1,
	migrate: createMigrate(migrations, { debug: isDevelopment() }),
};

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware => {
		const defaultMiddleware = getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}).concat();
		if (localStorage.getItem('logger')) defaultMiddleware.push(logger as Middleware);
		return defaultMiddleware;
	},
	devTools: isDevelopment(),
});

const persist = persistStore(store);

export { store, persist };
